<template>
  <div>
    <PageHeading
      title="Meu perfil"
      :pieces="['Home', 'Configurações avançadas']"
    />

    <ul class="nav nav-tabs">
      <li class="nav-item" :class="{ active: curTab === 0 }">
        <a class="nav-link" href="javascript:void(0)" @click="setCurTab(0)"
          >Configurações da API</a
        >
      </li>
      <li class="nav-item" :class="{ active: curTab === 1 }">
        <a class="nav-link" href="javascript:void(0)" @click="setCurTab(1)"
          >Taxas</a
        >
      </li>
      <li class="nav-item" :class="{ active: curTab === 2 }">
        <a class="nav-link" href="javascript:void(0)" @click="setCurTab(2)"
          >Meios de pagamento</a
        >
      </li>
    </ul>

    <div
      v-if="curTab == 0"
      class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"
    >
      <div class="card">
        <div class="card-body">
          <form
            @submit.prevent="saveConfig()"
            id="basicform"
            data-parsley-validate
          >
            <div class="form-group">
              <label for="api"
                >Endereço da API Varejo Fácil (já com a porta caso haja)</label
              >
              <input
                id="api"
                type="url"
                name="url"
                v-model="configs.api.url"
                data-parsley-trigger="change"
                required
                :disabled="isLoading"
                placeholder="Ex: https://meusupermercado.varejofacil.com"
                autocomplete="off"
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label for="version">Versão da API</label>
              <input
                id="version"
                type="text"
                name="version"
                required
                :disabled="isLoading"
                v-model="configs.api.version"
                placeholder
                autocomplete="off"
                value="v1"
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label for="inputUsername">Usuário</label>
              <input
                id="inputUsername"
                type="username"
                name="username"
                :disabled="isLoading"
                data-parsley-trigger="change"
                required
                v-model="configs.api.username"
                placeholder="username"
                autocomplete="off"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label for="inputPassword">Senha</label>
              <input
                id="inputPassword"
                type="password"
                :disabled="isLoading"
                v-model="configs.api.password"
                placeholder="******"
                required
                class="form-control"
              />
            </div>

            <hr />

            <div class="form-group">
              <label for="inputStore">Id da loja</label>
              <input
                id="inputStore"
                type="text"
                :disabled="isLoading"
                v-model="configs.store"
                placeholder="Informe o id da loja que será encontrada pelos clientes."
                required
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label for="lfv_ids">Ids das seções para LFV (Legumes, Frutas e Verduras)</label>
              <input
                id="lfv_ids"
                type="text"
                v-model="configs.api.lfvSections"
                :disabled="isLoading"
                placeholder="Informe os ids das seções separando por vírgula"
                required
                class="form-control"
              />
            </div>
            <div class="col-sm-13 pl-0">
              <p class="text-right" v-if="!isLoading">
                <button
                  type="submit"
                  :disabled="isLoading"
                  class="btn btn-space btn-primary"
                >
                  Salvar
                </button>
              </p>

              <p class="text-center" v-if="isLoading">PROCESSANDO...</p>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      v-if="curTab == 1"
      class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"
    >
      <div class="card">
        <div class="card-body">
          <form
            id="taxesForm"
            @submit.prevent="saveTaxes()"
            data-parsley-validate
          >
            <div class="form-group">
              <label for="api">Taxa administrativa</label>
              <input
                id="api"
                type="number"
                name="administrative-tax"
                step="any"
                v-model="configs.taxes.administrative"
                data-parsley-trigger="change"
                required
                :disabled="isLoading"
                placeholder="Ex: https://meusupermercado.varejofacil.com"
                autocomplete="off"
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label for="version">Taxa de distância (até 5Km)</label>
              <input
                id="version"
                type="number"
                name="to-5"
                required
                :disabled="isLoading"
                v-model="configs.taxes.distance[0]"
                placeholder
                autocomplete="off"
                value="v1"
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label for="version">Taxa de distância (de 6 a 10Km)</label>
              <input
                id="version"
                type="number"
                name="version"
                required
                :disabled="isLoading"
                v-model="configs.taxes.distance[1]"
                placeholder
                autocomplete="off"
                value="v1"
                class="form-control"
              />
            </div>

            <div class="form-group">
              <label for="version">Taxa de distância (acima de 10Km)</label>
              <input
                id="version"
                type="number"
                step="any"
                name="version"
                required
                :disabled="isLoading"
                v-model="configs.taxes.distance[2]"
                placeholder
                autocomplete="off"
                value="v1"
                class="form-control"
              />
            </div>

            <div class="col-sm-13 pl-0">
              <p class="text-right">
                <button
                  type="submit"
                  :disabled="isLoading"
                  class="btn btn-space btn-success"
                >
                  Salvar taxas
                </button>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      v-if="curTab == 2"
      class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12"
    >
      <div class="card">
        <div class="card-body">
          <form
            id="paymentsForm"
            @submit.prevent="savePaymentMethods()"
            data-parsley-validate
          >
            <div class="form-group">
              <label for="api">Formas de pagamento</label>
              <br />
              <div
                v-for="paymentMethod in configs.paymentMethods"
                :key="paymentMethod.description"
              >
                <input type="checkbox" v-model="paymentMethod.enabled" />
                {{ paymentMethod.description }}
              </div>
            </div>

            <div class="col-sm-13 pl-0">
              <p class="text-right">
                <button type="submit" class="btn btn-space btn-success">Salvar meios de pagamento</button>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import PageHeading from "@/views/admin/components/PageHeading.vue";
import { mapGetters, mapMutations } from "vuex";
import "firebase/firestore";
import { usersCollection } from "@/services/firestore-service";
import { testAPIConnection } from "@/services/supermarket";

export default {
  components: {
    PageHeading,
  },
  computed: {
    ...mapGetters(["userData"]),
  },
  mounted() {
    const configs = this.userData.configs;
    if (configs) {
      this.$data.configs.api = configs;
      this.$data.configs.store = this.userData.store;
    }

    if (this.userData.taxes) this.$data.configs.taxes = this.userData.taxes;
    if (this.userData.paymentMethods) {
      this.$data.configs.paymentMethods.forEach(
        (item) => (item.enabled = false)
      );
      this.userData.paymentMethods.forEach((item) => {
        let paymentMethod = this.$data.configs.paymentMethods.find(
          (p) => p.description === item
        );
        if (paymentMethod) paymentMethod.enabled = true;
      });
    }
  },
  data() {
    return {
      isLoading: false,
      curTab: 0,
      configs: {
        store: "",
        radius: 15,
        api: {
          username: "",
          password: "",
          url: "",
          version: "",
          lfvSections: null,
        },

        taxes: {
          administrative: 9.99,
          distance: [0, 0, 5],
        },
        paymentMethods: [
          { description: "DINHEIRO", enabled: true },
          { description: "CARTÃO DE CRÉDITO", enabled: true },
          { description: "CHEQUE A VISTA", enabled: true },
          { description: "CHEQUE PRE", enabled: true },
          { description: "CHEQUE POS", enabled: true },
          { description: "CHEQUE TEF", enabled: true },
          { description: "TICKET", enabled: true },
          { description: "CARTEIRA DIGITAL ITI", enabled: true },
          { description: "VENDA EM BOLETO", enabled: true },
        ],
      },
    };
  },
  methods: {
    ...mapMutations(['setUserData']),
    setCurTab(tabIndex) {
      if (this.$data.isLoading) return;
      this.$data.curTab = tabIndex;
    },
    getLfvSections() {
      const { lfvSections } = this.$data.configs.api; 
      if(lfvSections) {
        if(Array.isArray(lfvSections)) return lfvSections;
        return this.$data.configs.api.lfvSections.replace(/\s/g, '').split(',')
      }
      return [];
    },
    async savePaymentMethods() {
      if (this.$data.isLoading) return;

      const filtered = this.$data.configs.paymentMethods
        .filter((paymentMethod) => paymentMethod.enabled)
        .map((paymentMethod) => {
          return paymentMethod.description;
        });
      if (filtered.length === 0) {
        alert("Informe pelo menos um meio de pagamento");
        return;
      }

      try {
        this.$data.isLoading = true;
        await usersCollection.doc(this.userData.id).update({
          paymentMethods: filtered,
        });
      } catch (e) {
        this.$data.isLoading = false;
        alert("Houve um erro definir os meios de pagamento");
        return;
      }
      this.$data.isLoading = false;
      alert("Meios de pagamento definidos com sucesso.");
    },
    async saveTaxes() {
      if (this.$data.isLoading) return;
      try {
        this.$data.isLoading = true;
        await usersCollection.doc(this.userData.id).update({
          taxes: this.$data.configs.taxes,
        });
      } catch (e) {
        this.$data.isLoading = false;
        alert("Houve um erro definir as taxas");
        return;
      }
      this.$data.isLoading = false;
      alert("Taxas definidas com sucesso.");
    },
    async saveConfig() {
      const apiData = this.$data.configs.api;
      const storeId = this.$data.configs.store;

      try {
        if (
          !apiData.username ||
          !apiData.password ||
          !apiData.url ||
          !apiData.version ||
          !storeId
        ) {
          alert("Preencha os dados da API");
          return;
        }

        this.$data.isLoading = true;

        await testAPIConnection({
          apiData,
          storeId
        });

      } catch (e) {
        const data = e.response.data;
        this.$data.isLoading = false;
        if (data.message) {
          alert(data.message);
        }

        if(data.error) alert(data.error);
        return;
      }

      try {
        await usersCollection.doc(this.userData.id).update({
          store: storeId,
          hasConfig: true,
        });
        await usersCollection
          .doc(this.userData.id)
          .collection("configs")
          .doc("api")
          .set(
            {
              ...this.$data.configs.api,
              lfvSections: this.getLfvSections()
            },
            { merge: true }
          );
      } catch (e) {
        console.log(e);
        alert("Erro ao salvar as configurações.");
        this.$data.isLoading = false;
        return;
      }
      this.$data.isLoading = false;

      this.setUserData({
        configs: {...this.$data.configs},
        store: this.$data.configs.store
      });

      alert("As configurações foram definidas com sucesso.");
    },
  },
};
</script>
